import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { ANALYTICS_EVENT_LOGO_CLICK } from 'client/analytics/eventList';
import analytics from 'client/analytics';
import SrLink from 'client/components/SrLink/SrLink';

export const SR_LOGO_ALIGN_CENTER = 'center';
export const SR_LOGO_ALIGN_LEFT = 'left';

const SR_LOGO_ALIGN_TO_CLASSNAME_MAPPING = {
  [SR_LOGO_ALIGN_CENTER]: 'align-center',
  [SR_LOGO_ALIGN_LEFT]: 'align-left',
};

export const SR_LOGO_THEME_DEFAULT = 'default';
export const SR_LOGO_THEME_REDESIGN = 'redesign';

const SR_LOGO_THEME_TO_CLASSNAME_MAPPING = {
  [SR_LOGO_THEME_DEFAULT]: 'theme-default',
  [SR_LOGO_THEME_REDESIGN]: 'theme-redesign',
};

const SrLogo = ({ align, theme, redirectTo, disableRedirect }) => {
  const srLogoClassnames = classnames(
    'SrLogo logo',
    SR_LOGO_ALIGN_TO_CLASSNAME_MAPPING[align],
    SR_LOGO_THEME_TO_CLASSNAME_MAPPING[theme],
  );
  if (disableRedirect) {
    return (
      <div
        className={classnames(
          srLogoClassnames,
          'disabled',
        )}
      />
    );
  }
  return (
    <SrLink
      to={redirectTo}
      className={srLogoClassnames}
      onClick={() => analytics.track(ANALYTICS_EVENT_LOGO_CLICK)}
    />
  );
};

SrLogo.propTypes = {
  redirectTo: PropTypes.string,
  align: PropTypes.string,
  theme: PropTypes.string,
};

SrLogo.defaultProps = {
  redirectTo: '/',
  align: 'center',
  theme: 'default',
};

SrLogo.displayName = 'SrLogo';

export default SrLogo;
